import Vue from 'vue';
import store from './../../store';

const successAll = (response) => {
  store.dispatch('getAllLists', response.data);
  // Vue.router.push({
  //   name: 'home.index',
  // });
  // return lookupResponse.data;
};

// When the request fails
const failedAll = () => {
};

export default (spid) => {
  const axiosOptions = {
    timeout: 5000,
    headers: { 'X-Auth-Token': localStorage.getItem('jwt') },
    maxRedirects: 0,
    withCredentials: false,
  };
  // const queryinfo = {
  //   url: urltoquery,
  // };
  const thisurl = `/api/v1/sp/${spid}/list`;
  Vue.$http.get(thisurl, axiosOptions)
   .then((response) => {
     successAll(response);
   })
   .catch((error) => {
     failedAll(error);
   });
};



// WEBPACK FOOTER //
// ./src/app/services/list/getsplists.js